import { useEffect, useState } from 'react';
import ChangePhoto from './ChangePhoto';
import { Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'redux/store';
import { setMerchantPicture, removeMerchantPicture } from 'redux/slices/user/userSlice';
import CustomButton from 'components/Common/CustomButton';
import CardWrapper from 'components/Common/CardWrapper';
import { useNavigate } from 'react-router-dom';

function BusinessChangePhoto() {
    const dispatch = useDispatch<AppDispatch>();
    const merchantImage = useSelector((state: RootState) => state.user?.userInfo?.merchantImgUrl);
    const [imgValue, setImgValue] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        if (merchantImage) {
            setImgValue(merchantImage);
        } else {
            setImgValue('');
        }
    }, [merchantImage, dispatch]);

    const onSaveClick = async () => {
        const formData = new FormData();
        formData.append('file', imgValue);
        try {
            setLoading(true);
            const res: any = await dispatch(setMerchantPicture({ formData }));
            if (res?.payload?.code === 200) {
                navigate(-1);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log('upload img error');
        }
    };

    const onRemoveClick = async () => {
        // if user select an image and has not previously been uploaded the image then no need to call remove picture
        if (!merchantImage) {
            return setImgValue('');
        }
        try {
            setLoading(true);
            const res: any = await dispatch(removeMerchantPicture());
            const { payload } = res || {};
            if (Number(payload?.code) === 200) {
                setImgValue('');
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log('remove img error');
        }
    };

    return (
        <CardWrapper>
            {/* Component Which Has The Option To Upload/Select Images */}
            <ChangePhoto isLoading={loading} onRemoveClick={onRemoveClick} imgValue={imgValue} setImgValue={setImgValue} />
            {imgValue && (
                <Stack width="100%" alignItems="center" mt={4}>
                    <CustomButton
                        disabled={typeof imgValue === 'string'}
                        sx={{ width: '30%' }}
                        title="Save"
                        loading={loading}
                        onClick={onSaveClick}
                    />
                </Stack>
            )}
        </CardWrapper>
    );
}

export default BusinessChangePhoto;
